var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { ThemeProvider } from 'emotion-theming';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import styleService from '@nykaa/deals-utils/styles';
import personalizationUtil from '@nykaa/deals-utils/personalization';
import { EAGER_LOAD_IMAGES, EAGER_LOAD_INVENTORIES } from '@nykaa/deals-utils/images/constants';
import { DEFAULT_ROOT_MARGIN } from '@nykaa/deals-utils/impressions/constants';
import defaultWidgets from './renderer/defaultWidgets';
import BaseStyles from './BaseStyles';
import { IMPRESSION_LISTEN_TIMEOUT, IMP_DATA_COLLECTOR_TIMEOUT, IMP_STORAGE_KEY_V2, transformStyleWidgetTypes, } from './constants';
import { getPageStyle } from './helper';
import { getAppTheme } from './theme';
const customiseWidget = (widgetList, isPersonalizationSupported, isDesktop, isServer, eagerLoadImages, eagerLoadInventories, cta, rootMargin, remoteConfigs, store) => widgetList.reduce((returningWidgetArray, widgetItem, index) => {
    const { widgetData: { params: { styles = [] } = {} } = {} } = widgetItem;
    const cssStyle = styleService.transformStyles(widgetItem.widgetData.widgetType, styles, isDesktop, transformStyleWidgetTypes);
    if (personalizationUtil.isFullPersonalization(widgetItem.personalization)
        && widgetItem.isDataPersonalized) {
        returningWidgetArray.push(defaultWidgets({
            widgetData: widgetItem.widgetData,
            inventoryPosition: (index + 1),
            isServer,
            isDesktop,
            eagerLoadImages,
            eagerLoadInventories,
            cssStyle,
            cta,
            rootMargin,
            remoteConfigs,
            store,
        }));
    }
    else if (!personalizationUtil.isFullPersonalization(widgetItem.personalization)) {
        returningWidgetArray.push(defaultWidgets({
            widgetData: widgetItem.widgetData,
            inventoryPosition: (index + 1),
            isServer,
            isDesktop,
            eagerLoadImages,
            eagerLoadInventories,
            cssStyle,
            cta,
            rootMargin,
            store,
            remoteConfigs,
        }));
    }
    else if (!isPersonalizationSupported) {
        returningWidgetArray.push(defaultWidgets({
            widgetData: widgetItem.widgetData,
            inventoryPosition: (index + 1),
            isServer,
            isDesktop,
            eagerLoadImages,
            eagerLoadInventories,
            cssStyle,
            cta,
            rootMargin,
            store,
            remoteConfigs,
        }));
    }
    return returningWidgetArray;
}, []);
const RenderAll = ({ widgetList, isServer = false, isDesktop = false, shouldLoadFonts = false, fontCDNPath = '', store = 'nykaa', impressionEvent, asyncImpressionCallback, syncImpressionCallback, eagerLoadImages = EAGER_LOAD_IMAGES, eagerLoadInventories = EAGER_LOAD_INVENTORIES, theme, isPersonalizationSupported, cta = { wishlist: {} }, rootMargin = DEFAULT_ROOT_MARGIN, remoteConfigs = {}, }) => {
    useEffect(() => {
        let impressionListener;
        let dataCollectorListener;
        const impressionsListenerForTab = () => __awaiter(void 0, void 0, void 0, function* () {
            yield ImpressionsHandler.pushImpressions();
            yield ImpressionsHandler.pushImpressions(IMP_STORAGE_KEY_V2);
        });
        ImpressionsHandler.initializeImpressionEvent(impressionEvent);
        if (asyncImpressionCallback) {
            ImpressionsHandler.initialize(asyncImpressionCallback, syncImpressionCallback);
            impressionListener = window.setInterval(() => {
                ImpressionsHandler.pushImpressions();
                ImpressionsHandler.pushImpressions(IMP_STORAGE_KEY_V2);
            }, IMPRESSION_LISTEN_TIMEOUT);
            dataCollectorListener = window.setInterval(() => {
                ImpressionsHandler.dataCollector();
            }, IMP_DATA_COLLECTOR_TIMEOUT);
            window.addEventListener('beforeunload', impressionsListenerForTab);
        }
        return () => {
            if (asyncImpressionCallback && impressionListener) {
                window.removeEventListener('beforeunload', impressionsListenerForTab);
                clearInterval(impressionListener);
                clearInterval(dataCollectorListener);
            }
        };
    }, []);
    const themeValue = getAppTheme(theme);
    return (React.createElement(ThemeProvider, { theme: themeValue },
        shouldLoadFonts && React.createElement(BaseStyles, { fontCDNPath: fontCDNPath }),
        React.createElement("div", { style: getPageStyle(widgetList) }, customiseWidget(widgetList, !!isPersonalizationSupported, !!isDesktop, isServer, eagerLoadImages, eagerLoadInventories, cta, rootMargin, remoteConfigs, store))));
};
export default RenderAll;
